import { connect } from 'react-redux'
import DonorListCard from '../components/DonorListCard'
import { donor } from '../actions'

const mapStateToProps = (state, ownProps) => {
  const { language } = state.user
  return ({
    language
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    fetch: () => {
      return dispatch(donor())
    }
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DonorListCard)


// WEBPACK FOOTER //
// ./src/Parts/DonorListCard/containers/DonorListCard.js